/* Retire legacy dispatch properties without changing quantities or purchase plans. */
(function () {
  'use strict';
  var pending = null;
  function hasLegacyProperties(item) {
    var properties = item.properties || {};
    return Object.prototype.hasOwnProperty.call(properties, 'Preorder') || Object.prototype.hasOwnProperty.call(properties, '_preorder');
  }
  function standardProperties(properties) {
    var result = Object.assign({}, properties || {});
    delete result.Preorder;
    delete result._preorder;
    // Shopify cannot replace an existing properties object with {}. A private
    // status keeps the line intact and never displays a label at checkout.
    if (!Object.keys(result).length) result._order_type = 'standard';
    return result;
  }
  function ensure(routes) {
    if (pending) return pending;
    routes = routes || {};
    function json(response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    }
    pending = fetch((routes.cart || '/cart') + '.js', {
      headers: { Accept: 'application/json' }, cache: 'no-store'
    }).then(json).then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
      var remaining = cart.items.length;
      function next(current) {
        if (!current || !Array.isArray(current.items)) throw new Error('Invalid cart response');
        var item = current.items.find(hasLegacyProperties);
        if (!item) return current;
        if (remaining-- <= 0) throw new Error('Cart update incomplete');
        // Re-read line keys from every response: removing properties may merge lines.
        return fetch((routes.change || routes.cartChange || '/cart/change') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: standardProperties(item.properties) })
        }).then(json).then(next);
      }
      return next(cart);
    }).then(function (cart) { pending = null; return cart; }, function (error) { pending = null; throw error; });
    return pending;
  }
  window.CxCartCleanup = { ensure: ensure };
})();
